import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { pathInLang, saveLang } from '../../utils/langPath';

export default function LanguageToggle() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const isHebrew = i18n.language === 'he';

  // Same page in the other copy (Hebrew = plain address, English = /en/…), and
  // remember the choice so links in the other language bring them back here.
  const toggleLanguage = () => {
    const newLang = isHebrew ? 'en' : 'he';
    try {
      saveLang(window.localStorage, newLang);
    } catch {
      // Storage blocked: the choice just isn't remembered.
    }
    window.history.replaceState(null, '', pathInLang(location.pathname, newLang) + location.search + location.hash);
    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === 'he' ? 'rtl' : 'ltr';
    document.documentElement.lang = newLang;
  };

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      aria-label={t('a11y.switchLanguage')}
      className="flex items-center gap-1 px-3 py-1 rounded-[10px] border border-ink/15 text-ink text-sm font-medium hover:bg-fog transition-colors"
    >
      {/* The other language is grey (not see-through), so it still has enough contrast. */}
      <span lang="en" className={isHebrew ? 'text-ash' : 'font-bold'}>EN</span>
      <span className="text-ash" aria-hidden>|</span>
      <span lang="he" className={isHebrew ? 'font-bold' : 'text-ash'}>עב</span>
    </button>
  );
}
